import type { ReactElement, ReactNode } from 'react';

import { SecurityProvider as OAuthProvider } from '@virtuslab/react-oauth2';

import type { Config } from '../../../config';

import Loading from '../../molecules/Loading';

import DisplayAuthError from './molecules/DisplayAuthError';

type SecurityProviderConfig = Pick<Config, 'baseUrl' | 'isLocalDevelopment' | 'keycloak'>;

type Props = Readonly<{
  children: ReactNode;
  redirectTo: string;
  config: SecurityProviderConfig;
}>;

const SecurityProvider = ({
  children, redirectTo, config,
}: Props): ReactElement => (
  <OAuthProvider
    url={config.keycloak.url}
    realm={config.keycloak.realm}
    clientId={config.keycloak.clientID}
    silentCheckSsoRedirectUri={`${config.baseUrl}/silent-check-sso.html`}
    fallback={<Loading />}
    error={({ error }) => (config.isLocalDevelopment
      ? null
      : <DisplayAuthError error={error} logoutRoute={redirectTo} />)}
  >
    {children}
  </OAuthProvider>
);

export default SecurityProvider;
